import { WidgetConfiguration } from '@/model/configuration/WidgetConfiguration'
import { EnvConfiguration } from '@/model/configuration/EnvConfiguration'
import { ExtSysConfiguration } from '@/model/configuration/ExtSysConfiguration'

export class Configuration {
  widget = new WidgetConfiguration()
  envConf = new EnvConfiguration()
  extSysConf = new ExtSysConfiguration()
  playingCustomerRestriction = true
  advertPositions: Array<number> = []
  appVersion = ''
  pageSize = 50
  bulkSize = 50
  bestPageSize = 10
  maxBestPageSize = 100
  underArticlePageSize = 3
  profilePageSize = 10
  maxPostTreeDepth = 5
}
